import React from 'react';
import { useFormik } from 'formik';
import { InputProps as StandardInputProps } from '@mui/material/Input/Input';
import { Fade, Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import { FormValues } from '../types/setpointLimitProfileDetailFormValues';
import BorderedSection from '../../shared/borderedSection';
import Typography from '@mui/material/Typography';
import { TemperatureUnit } from '../../../system/models/temperatureUnits';

export function SetpointLimitProfileGeneralTab({
  formik,
  onChange,
  handleSetpointLimitChange,
  targetUnits,
  isSuper,
}: {
  formik: ReturnType<typeof useFormik<FormValues>>;
  onChange: StandardInputProps['onChange'];
  isSuper: boolean;

  handleChange: (
    changes: Record<string, number | string>,
    ensureConformity?: boolean,
  ) => void;
  handleSetpointLimitChange: (
    key: string,
    value: number,
  ) => Record<string, number | string | boolean | string[]>;
  targetUnits: TemperatureUnit;
}) {
  return (
    <Fade in={true} style={{ transitionDuration: '1100ms' }}>
      <div>
        <TextField
          fullWidth
          autoFocus
          id="name"
          name="name"
          placeholder="Setpoint Profile Name"
          label="Name"
          value={formik.values.name}
          onChange={onChange}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
        />
        {isSuper ? (
          <div>
            <br />
            <br />
            <TextField
              fullWidth
              id="id"
              name="id"
              disabled={true}
              placeholder="Setpoint Profile ID"
              label="Policy Id"
              value={formik.values._id}
              onChange={onChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </div>
        ) : null}
        <br />
        <br />
        <BorderedSection title={`Setpoint Limits (in  \xB0${targetUnits})`}>
          <Typography variant="caption">
            Template values. Equipment domains are checked when this policy is
            assigned.
          </Typography>
          <Grid container spacing={2}>
            {(
              [
                'minHeatSetpointLimit',
                'maxHeatSetpointLimit',
                'minCoolSetpointLimit',
                'maxCoolSetpointLimit',
              ] as const
            ).map((field) => (
              <Grid item xs={12} sm={6} key={field}>
                <TextField
                  fullWidth
                  type="number"
                  label={`${field.startsWith('min') ? 'Minimum' : 'Maximum'} ${field.includes('Heat') ? 'heat' : 'cool'} (°${targetUnits})`}
                  value={formik.values[field] ?? ''}
                  inputProps={{ step: 'any' }}
                  error={Boolean(formik.errors[field])}
                  helperText={formik.errors[field]}
                  onChange={(event) => {
                    if (event.target.value.trim())
                      handleSetpointLimitChange(
                        field,
                        Number(event.target.value),
                      );
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </BorderedSection>
      </div>
    </Fade>
  );
}
